import React from "react";
import { MusicPracticeRoomContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { userService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Headers, Cards, Displays, Navigations } from "components";

class MusicPracticeRoomContainer extends React.Component {
  state = { isLoading: true };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let res = await userService.GET_ROOM_LIST(`?pagination=false&type=2`);
    if (res && res.status === 200) {
      this.setState({
        data: {
          ...res.data,
          docs: res.data.docs.sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at),
          ),
        },
        isLoading: false,
      });
    }
  };

  handleBooking = (e) => {
    // เลือกห้องจากรายการแล้ว ข้าม step 1 แต่ต้องผ่านขั้นข้อมูลติดต่อก่อนเลือกวัน/เวลา
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${e._id}/booking/contact?room_ref_id=${e._id}`,
    );
  };

  handleClickDetail = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${e._id}`);
  };

  render() {
    const { t } = this.props;
    const { isLoading, data } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Practice Room", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}`,
      },
    ];
    return (
      <MusicPracticeRoomContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="music_practice_container">
          <div className="header_layout">
            <Headers.NewPageHeader
              title={"MUSIC PRACTICE ROOM"}
              sub_title={"ห้องซ้อมดนตรี"}
            />
          </div>
          <div className="detail_layout">
            <div>{this.props.t("Music Practice Room Detail and Booking Steps", { ns: "room" })}</div>
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <div className="musichall_page">
              {data &&
                data.docs.map((e, i) => (
                  <div key={i} className="musichall_item">
                    <Cards.MusicHallItem
                      {...e}
                      onClickDetail={() => this.handleClickDetail(e)}
                      onBooking={() => this.handleBooking(e)}
                    />
                  </div>
                ))}
            </div>
          )}
        </div>
      </MusicPracticeRoomContainerStyled>
    );
  }
}

export default withTranslation(["common", "room"])(withRouter(MusicPracticeRoomContainer));
